import { i18n, TranslationFunction, TranslationOptions } from 'i18next'

import { LangChangedAction } from '../store/i18n.actions'

import { DATE_FORMATS } from '../../shared'
// import { DEFAULT_LANG_KEY, NS } from '../i18n.config'
import { Logger } from './logger.service'

type Action = {
  type: string
  payload?: any
}
type EmitFn = (action: Action) => Action
interface ConfigOptions {
  emitFn: EmitFn
}

// type Locale = {
//   [key: string]: string
// }
export class I18nService {
  constructor(private i18next: i18n, private logger: Logger, private emit: EmitFn = (action: Action) => action) {
    this.onInit()
  }

  configure({ emitFn }: ConfigOptions) {
    this.emit = emitFn
  }

  get currentLang() {
    return this.i18next.language
  }

  setNewLanguageKeys(keys: any, langCode: string) {
    // const actualLang = langCode ? langCode : DEFAULT_LANG_KEY
    // keys.map((item: Locale) => {
    //   this.i18next.addResource(actualLang, NS, item.key, item.value, { keySeparator: '.' })
    // }, {})

    return this.changeLanguage(langCode)
  }

  setDateFormatPatterns(langCode: string) {
    Object.assign(window, {
      __LocaleSettings: {
        // tslint:disable-next-line:no-string-literal
        ...(window as any)['__LocaleSettings'],
        formats: DATE_FORMATS[langCode],
      },
    })
  }

  changeLanguage(languageKey: string): Promise<TranslationFunction> {
    return new Promise((resolve, reject) => {
      if (this.currentLang === languageKey) {
        this.logger.info(`Lang ${languageKey} already set, no action`)

        return resolve(this.i18next.t)
      }

      this.i18next.changeLanguage(languageKey, (err: any, t: TranslationFunction) => {
        if (err) {
          reject(err)
        } else {
          resolve(t)
        }
      })
    })
  }
  /**
   * NOTE: Don't use this within components, because props won't change and component won't be re-rendered
   * @param key
   * @param options
   */
  translate(key: string | string[], options?: TranslationOptions) {
    return this.i18next.t(key, options)
  }

  private onInit() {
    this.i18next.on('languageChanged', (newLanguage) => {
      this.emit(new LangChangedAction(newLanguage))
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/i18n.service.ts